import { atom } from 'jotai';

// HEV の選択中 gear_id。BEV では使用しない（HEV対応仕様 §3.2）。
// R / L とも calc 配下の gear タブ/セレクタの選択状態として共有する。
export const gearIdAtom = atom<string | null>(null);
